
jQuery(document).ready(function() {
const $ = jQuery;

$(window).scroll(function() {
        var windowBottom = $(this).scrollTop() + $(this).innerHeight();
      
        $(".scroll-down").each(function() {
       
           if ($(this).css("opacity" ) !== 0 ) {
            $(this).css("opacity", 1 - $(window).scrollTop() * 0.002)
           }

          if ($(this).css("opacity" ) <= 0 ) {
              $(this).css("display", 'none');
           } else {
              $(this).css("display", 'block');
           }
        });
      }).scroll();



//     function hideScrollDown() {
//      windowBottom = $(this).scrollTop() + $(this).innerHeight();
//     if ($(window).width() > 1200) {
//         $(window).scroll(function () {
//         // isNavIfxed();
//         });
//         // isNavIfxed();
//     }
// }
// hideScrollDown();

})